import { CanActivateFn } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

export const settingsGuard: CanActivateFn = (route, state) => {
  window.location.href = AuthService.getSettingsUri;
  return true;
};
